// assets/js/product-features-splide.js
import Splide from '@splidejs/splide';

export function initProductFeaturesSplide() {
  const sliders = document.querySelectorAll('.js-product-features-splide');
  if (!sliders.length) return;

  sliders.forEach((el) => {
    new Splide(el, {
        type: 'loop',
        perPage: 1,
        autoplay: true,
        interval: 4000,
        pauseOnHover: true,
        pauseOnFocus: true,
        arrows: true,      // ✅ ON
        pagination: false, // ✅ OFF
        speed: 600,
        }).mount();
  });
}
